import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { sendTemplateEmail } from 'modules/accommodations/features/reservations/api';

export const useCalculationTemplateMutation = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate: sendMailTask, isLoading: isSending } = useMutation(sendTemplateEmail, {
    onSuccess: () => successToast(t('Mail sent successfully.')),
    onError: () => errorToast(),
  });

  return {
    isSending,
    sendMailTask,
  };
};
